
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

import { Draft } from "immer";
import OrderProgressModeState from "@dana/Store/Data/OrderProgressLoading/OrderProgressLoadingState";

const initialState: OrderProgressModeState = {
    isOn: false,
};

const orderProgressModeStateImmerReducer = createTypedReducerWithImmer(initialState, {

    "OrderProgressMode/IsOn": (draft: Draft<OrderProgressModeState>, action: { isOn: boolean }) => {
        draft = { ...draft, isOn: action.isOn };
        return draft;
    },

});

(reducers as any).orderProgressMode = orderProgressModeStateImmerReducer;

type OrderProgressModeLoadingReducers = {
    orderProgressMode: typeof orderProgressModeStateImmerReducer;
};

export type OrderProgressModeActions = Parameters<OrderProgressModeLoadingReducers[keyof OrderProgressModeLoadingReducers]>[1] | AnyAction;

